import Vue from 'vue'
import { Message } from 'element-ui'

/**
 * 1.数据处理方法
 * macroName 方法名（随便定义）
 * macroCode 方法标识   （随便定义）
 * describe:{
 * "showSave":true, // 是否需要保存数据，包络线不需要保存数据
 * "type":3 // 跟后端约定的参数
 * "params":[{"model":"noise","name":"浮动系数：","value":0.5,"type":"slider","min":0.01,"step":0.01,"max":0.9}]}}  // model名字 跟后端约定的参数
 * }
 */;
import i18n from '@/utils/i18n'

// 包了一层，打包后会保留i18n这个名字
const myI18n = {
    i18n: i18n
}
export const dealDataList = [
    { macroName: myI18n.i18n.t('卡尔曼滤波平滑'), macroCode: "kalman", describe: { "showSave": true, "type": 3, "params": [{ "model": "noise", "name": myI18n.i18n.t('浮动系数') + "：", "value": 0.5, "type": "slider", "min": 0.01, "step": 0.01, "max": 0.9 }] } },
    { macroName: myI18n.i18n.t('去粗差'), macroCode: "gross", describe: { "showSave": true, "type": 5 } },
    { macroName: myI18n.i18n.t('多项式'), macroCode: "polynomial", describe: { "showSave": true, "type": 4 } },
    { macroName: myI18n.i18n.t('上包络线'), macroCode: "upEnvelope", describe: { "showSave": true, "type": 2, "params": [{ "model": "coefficient", "name": myI18n.i18n.t('缩放系数'), "type": "input-number", "min": 0, "max": 1 }] } },
    { macroName: myI18n.i18n.t('下包络线'), macroCode: "downEnvelope", describe: { "showSave": true, "type": 2, "params": [{ "model": "coefficient", "name": myI18n.i18n.t('缩放系数'), "type": "input-number", "min": 0, "max": 1 }] } }
]
//获取包络线
export function getCorrectionCurve(chartList, params, envelopeType) {
    let sendData = { ...{ dataIds: getSendData(chartList, false) }, ...params }
    return new Promise((resolve) => {
        Vue.prototype.$httpAnalytical.post("/curve/getCorrectionCurve", sendData).then(data => {
            let dataObj = {}
            data.data.forEach(item => {
                item.data.forEach(it => {
                    dataObj[item.dataId + "-" + it.phyType] = it.respData[envelopeType]
                })
            })
            chartList.forEach(item => {
                let addLineList = [];
                item.lineList.forEach(it => {
                    let newIt = JSON.parse(JSON.stringify(it))
                    newIt.phyName = envelopeType == 'upEnvelope' ? myI18n.i18n.t('上包络线') : myI18n.i18n.t('下包络线')
                    newIt.datas.map((i, idx) => {
                        i[1] = dataObj[item.dataId + "-" + it.phy][idx]
                    })
                    addLineList.push(newIt)
                })
                item.dataProcessList = addLineList
            })
            resolve(chartList)
        })
    })
}
/**
 * 
 * @param {*} chartList 
 * @param {*} isOverlay 数据是否叠加处理
 * @returns 
 */
function getSendData(chartList, isOverlay) {
    let dataObj = [];
    chartList.forEach(item => {
        let datas = [];
        let lineList = isOverlay ? (item.dataProcessList || item.lineList) : item.lineList;
        lineList.forEach(it => {
            datas.push({
                phyType: it.phy,
                phyData: it.datas.map(i => i[1])
            })
        })
        dataObj.push({
            dataId: item.dataId,
            data: datas
        })
    })
    return dataObj;
}
//数据处理
export function dataProcess(chartList, params) {
    let sendData = { ...{ dataIds: getSendData(chartList, false) }, ...params }
    return new Promise((resolve) => {
        Vue.prototype.$httpAnalytical.post("/curve/getCorrectionCurve", sendData).then(data => {
            chartList = renderData(chartList, data)
            resolve(chartList)
        })
    })
}
function renderData(chartList, data) {
    let dataObj = {}
    data.data.forEach(item => {
        item.data.forEach(it => {
            dataObj[item.dataId + "-" + it.phyType] = it.respData
        })
    })
    chartList.forEach(item => {
        let addLineList = JSON.parse(JSON.stringify(item.lineList))
        addLineList.forEach((it, idx) => {
            it.phyName = myI18n.i18n.t('处理之后的值');//标识处理之后的数据
            if (dataObj[item.dataId + "-" + it.phy].length) {
                it.datas.map((i, idx) => {
                    i[1] = dataObj[item.dataId + "-" + it.phy][idx]
                })
            } else {
                if (item.dataProcessList && item.dataProcessList[idx]) {
                    it.datas = item.dataProcessList[idx].datas
                } else {
                    // 如果没有处理后的数据 datas置空
                    it.datas = [];
                }
            }
        })
        item.dataProcessList = addLineList
    })
    return chartList
}
export function saveDataProcess(chartList) {
    let states = [], pointIds = []
    chartList.forEach(item => {
        pointIds.push(item.dataId)
        item.dataProcessList.forEach((it, index) => {
            // 处理之后的数据放到保存数据中
            let curLine = item.lineList[index]
            // 只保留更改过后的值进行保存
            it.datas = it.datas.filter((i, idx) => curLine.datas[idx][1] != i[1])
            let datas = it.datas.map(i => {
                return {
                    data_id: item.dataId,
                    data_time: i[0],
                    phy: it.phy,
                    data: i[1]
                }
            })
            states = states.concat(datas)
        })
    })
    return new Promise((resolve) => {
        Vue.prototype.$httpEs.post("/point/editPointData", { states: states, pointIds: pointIds }).then(data => {
            Message({
                message: myI18n.i18n.t('操作成功'),
                type: 'success'
            })
            resolve(data)
        })
    })
}